module.exports = __webpack_public_path__ + "media/assets/images/category/Random@2x-71750838ac619a354a132c29e1465513.png";